import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Button } from 'react-bootstrap';
import ModalComponent from '../../Layout/Modal';
import Select from 'react-select';
import makeAnimated from 'react-select/lib/animated';
import { appConstants,areaCode } from '../../../_constants';
import Header from '../../Inc/Layout/Header.js';
import Footer from '../../Inc/Layout/Footer.js';
import { uploadResumeFile, getAllCityAction } from '../../../actions/FindRecCompany';
import { notification } from 'antd';
import { getAllHome } from '../../../actions/home';
import { resumeListAction, deleteResumeAction } from '../../../actions/SendResume';
import { getProfileAction, deactivateAccountAction, updateProfileAction } from '../../../actions/Profile';
import moment from 'moment-timezone';
import Chat from '../../Chat/Chat.js';
import $ from 'jquery';
import loadingImage from "../../loadingImageRc.gif";

let className = "";
let fieldsArr = []
let modelTitle = "";
let modelState = "";
let modelBodyData = {};
let modelFooterData = {};
let modelAction = "";

class JobSeekerProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tabTypeShow: "tab",
            fieldsList: [],
            tags: [],
            tagvalue: [],
            cityOption: [],
            suggestions: [],
            resumeUploadModal: false,
            imageUpload: false,
            deleteRequest: false,
            viewAllModal: false,
            editprofileModal: false,
            resumeUpload: false,
            resumeUploadSuccess: true,
            requestServer: true,
            request: true,
            disabled: true,
            ProfileDetail: {phoneExt:"+1"},
            resumeCount: 0,
            sizePerPage: 10,
            currentPage: 1,
            deleteConfirmModal: false,
            deleteConfmModalAccount: false,
            deleteResumeFile: {},
            resumeWithName: "",
            resumeList: []
        }
    }

    componentWillMount() {
        this.props.getProfileAction();
        let reqObj = {
            "limit": 10,
            "offset": 0,
            "order": "name",
            "direction": "desc",
            "search": "",
            "status": ""
        }
        //this.profile();
        this.props.getAllHome(reqObj);
    }

    componentDidMount() {
        this.resumeList(10, 0);
        this.props.getAllCityAction();
    }

    componentWillReceiveProps(nextProps) {
        const { imageUpload, resumeUpload } = this.state
        const location = this.props && this.props.history && this.props.history.location;
        const {state} = location
        const chatSectionModule = state.chatSectionModule
        if (chatSectionModule) {
            this.setState({
                tabTypeShow: "tabFour"
            })
            $(".tab-pane").removeClass("active")
            $("a").removeClass("active")
            $("#tabFour").addClass("active")
            $("#btntabFour").addClass("active")
        }

        switch (nextProps.detailTypa) {
            case "getData":
                if (nextProps.ProfileDetail && nextProps.ProfileDetail.statusCode === 200 && this.state.request && nextProps.ProfileDetail.data) {
                    var specializations = nextProps.ProfileDetail && nextProps.ProfileDetail.data && nextProps.ProfileDetail.data.specializations ? nextProps.ProfileDetail.data.specializations : [];
                    var profileDetailData = nextProps.ProfileDetail.data
                    
                    localStorage.setItem('userData', JSON.stringify(profileDetailData))
                    var tags = this.state.tags
                    if (specializations.length > 0) {
                        tags = [];
                        for (var x in specializations) {
                            tags.push({ id: specializations[x], text: specializations[x] })
                        }
                    }
                    // if(profileDetailData.phoneExt){
                    //    profileDetailData.areaCode = areaCode.find(item=>item.value ==profileDetailData.phoneExt);
                    // }
                    localStorage.setItem('userData', JSON.stringify(profileDetailData))
                    this.setState({
                        ProfileDetail: profileDetailData,
                        tags: tags,
                        disabled: true,
                        request: false,
                        requestServer: false,
                        resumeUpload: false,
                    });
                }
                break;
            case "updateData":
                let _this = this;
                if (nextProps.ProfileDetail.statusCode === 200) {
                    modelState = false;

                    _this.setState({ editprofileModal: false, resumeUploadModal: false });
                    notification.success({
                        message: nextProps.ProfileDetail.msg,
                        className:'successNotification',
                        duration: 3
                    });
                    this.setState({
                      request: true,
                    })
                    this.profile();
                }
                break;

            case "deactiveAccount":
                if (nextProps.ProfileDetail.statusCode === 200) {
                    notification.success({
                        message: "Youer ACcount Deactivated successfully",
                        className:'successNotification',
                        duration: 3
                    });

                    localStorage.removeItem('userLogin')
                    localStorage.removeItem('userData')
                    this.props.history.push({
                        pathname: "/"
                    });
                    window.location.reload();
                }
                break;
            default:
                return true;
        }


        if (nextProps.responseDelet && nextProps.responseDelet.statusCode && this.state.deleteRequest) {
            notification.success({
                message: nextProps.responseDelet.msg,
                className:'successNotification',
                duration: 3
            });
            modelState = false;
            this.profile();
            this.setState({
                request: true,
                deleteRequest: false,
                deleteConfirmModal: false
            });
        }

        if (nextProps && nextProps.resumeList && nextProps.resumeList.data && nextProps.resumeList.data.data.length > 0) {
            this.setState({
                resumeCount: nextProps.resumeList.data.count,
                resumeList: nextProps.resumeList.data.data,
                //request:false,
                requestServer: false,

            })
        }
        if (nextProps.image && nextProps.image.statusCode && nextProps.image.statusCode === 200 && imageUpload) {
            this.setState({
                imageUpload: false
            })
            var userDetail = this.state.ProfileDetail
            userDetail['image'] = nextProps.image.file_name;
            this.props.updateProfileAction(userDetail)
        }

        if (nextProps.setCity && Array.isArray(nextProps.setCity)) {
            let ProfileDetail = this.state.ProfileDetail
            ProfileDetail["preferredCity"] = nextProps.setCity;
            this.setState({
                ProfileDetail: ProfileDetail
            });

        }

        if (nextProps.setCityB && Array.isArray(nextProps.setCityB)) {
            let ProfileDetail = this.state.ProfileDetail
            ProfileDetail["companyAddress"] = nextProps.setCityB;
            this.setState({
                ProfileDetail: ProfileDetail

            });
        }

        if (nextProps.image && nextProps.image.statusCode && nextProps.image.statusCode === 200 && resumeUpload) {

            let profileDetail = this.state.ProfileDetail;
            let reqOb = {
                name: this.state.resumeWithName,
                resumeImage: nextProps.image.file_name
            }
            if (Array.isArray(profileDetail.resume)) {
                profileDetail.resume.push(reqOb)
            } else {
                profileDetail.resume = []
                profileDetail.resume.push(reqOb)
            }

            this.setState({
                request: true,
                requestServer: true,
                resumeUrl: nextProps.image.file_name,
                resumeUpload: false,
            },() =>{
                this.props.updateProfileAction(profileDetail) 
            })
        }

        if (nextProps.allCitySuggetion && nextProps.allCitySuggetion.statusCode === 200) {
            let cityData = (nextProps.allCitySuggetion.cityData && nextProps.allCitySuggetion.cityData.data) ? nextProps.allCitySuggetion.cityData.data : [];
            let cityArr = [];
            for (var z in cityData) {
                let obj = {};
                obj.label = cityData[z].cityName;
                obj.city = cityData[z].cityName;
                obj.value = cityData[z]._id;
                obj.state = cityData[z].stateId;
                obj.state = cityData[z].stateName;
                obj.country = cityData[z].countryName;
                obj.zipCode = "";
                obj.countryId = cityData[z].countryId;
                obj.address = cityData[z].cityName;
                obj.coordinates = cityData[z].coordinates;

                cityArr.push(obj);
            }
            this.setState({
                cityOption: cityArr
            })
        }
    }

    resumeList = (sizePerPage, page) => {
        let reqObj = {
            "limit": (sizePerPage ? sizePerPage : 10),
            "offset": (page ? page : 0),
            "order": "",
            "direction": "",
            "search": "",
        }
        this.props.resumeListAction(reqObj);
    }

    profile = (name, value) => {
        this.props.getProfileAction();
    }

    editProfile = () => {
        this.setState({ disabled: false });
    }

    cancelProfile = () => {
        this.profile();
        this.setState({ request: true, disabled: true });
    }

    handleChangeradioForRadio = (value, e) => {
        let ProfileDetail = this.state.ProfileDetail;
        ProfileDetail.messageEmailNotification = value;
        this.setState({
            ProfileDetail: ProfileDetail,
        })
    }

    handleChangeSelectCity = (name, value) => {
        let ProfileDetail = this.state.ProfileDetail
        ProfileDetail.companyAddress = value;
        ProfileDetail.preferredCity = [];
        for (var x in value) {
            ProfileDetail.preferredCity.push(value[x].label)
        }
        this.setState({
            ProfileDetail: ProfileDetail,
            disabled: false
        });
    }

    onChange1 = (e) => {
        this.setState({
            resuMeFile: e.target.files[0],
            resumeUpload: true,
            resumeUploadSuccess: false,
            resumeWithName: e.target.files[0].name
        });
        //this.props.uploadResumeFile(e.target.files[0])
    }

    upDateProfile = () => {
        this.setState({
            request: true,
            requestServer: true
        })
        this.props.updateProfileAction(this.state.ProfileDetail)
    }

    upDateProfileResume = () => {
        this.props.uploadResumeFile(this.state.resuMeFile, this.state.resumeWithName)
    }

    myFunction = () => {
        var dots = document.getElementById("dots");
        var moreText = document.getElementById("more");
        var btnText = document.getElementById("myBtn");

        if (dots.style.display === "none") {
            dots.style.display = "inline";
            btnText.innerHTML = "Read more";
            moreText.style.display = "none";
        } else {
            dots.style.display = "none";
            btnText.innerHTML = "Read less";
            moreText.style.display = "inline";
        }
    }

    fields() {
        fieldsArr = [];
        const { fieldsList } = this.state
        var i = 0;
        for (i in fieldsList) {
            fieldsArr.push(<div className="col-md-6"><input type="checkBox" name="fields" id={fieldsList[i]._id} value={fieldsList[i]._id} onChange={this.handleChangeRadio} />{fieldsList[i].name}</div>)
        }
    }

    handleDelete = (i) => {
        const { tags, tagvalue } = this.state;
        this.setState({
            tags: tags.filter((tag, index) => index !== i),
            tagvalue: tagvalue.filter((tagvalue, index) => index !== i),
        });
    }

    handleDrag = (tag, currPos, newPos) => {
        const tags = [...this.state.tags];
        const newTags = tags.slice();
        newTags.splice(currPos, 1);
        newTags.splice(newPos, 0, tag);
        this.setState({ tags: newTags });
    }

    handleAddition = (tag) => {
        var tagvalue = tag.text;
        this.setState(state => ({ tags: [...state.tags, tag] }));
        this.setState(state => ({ tagvalue: [...state.tagvalue, tagvalue] }));

    }

    handleChange = e => {
        e.preventDefault();
        let { ProfileDetail } = this.state;
        var value = e.target.value;

        if (e.target.name === "resumeWithName") {
            this.setState({
                resumeWithName: value
            })
        } else if (e.target.name === 'phone' || e.target.name === 'additionalContact') {
            var n = e.target.value;
            //value = null;
            if( n.length < 11){
                value = n.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');
                value = parseInt(value, 10);
            }else{
                value = ProfileDetail[e.target.name];
            }
        }
        ProfileDetail[e.target.name] = value;
        this.setState({ ProfileDetail: ProfileDetail,disabled: false });
    };

    handleChangeSelect = (name, value) => {
        let ProfileDetail = this.state.ProfileDetail
        ProfileDetail["categoryId"] = [];
        ProfileDetail[name] = value
        for (var i in value) {
            ProfileDetail["categoryId"].push(value[i].value);
        }
        this.setState({
            ProfileDetail: ProfileDetail
        });
    }

    handleChangeSelectPhone = (name, value) => {
        let ProfileDetail = this.state.ProfileDetail
        ProfileDetail["areaCode"] = value
        ProfileDetail[name] = value.value
        this.setState({
            ProfileDetail: ProfileDetail
        });
    }

    viewAllOption = (type, e) => {
        if (!this.state.viewAllModal) {
            this.resumeList();
        }
        this.setState({
            viewAllModal: !this.state.viewAllModal
        });
    }

    formatDate(iso_date) {
        if (typeof iso_date === 'undefined') {
            return moment().tz().format(appConstants.DATEFORMATNOTTIME);
        }
        return new Date(iso_date).toLocaleDateString("en-US");
    }

    onError(e) {
        console.log(e, 'error in file-viewer');
    }

    addNewResume = () => {
        const { profileDetail } = this.state
        if (profileDetail && profileDetail.resume && profileDetail.resume.length > 5) {
            notification.success({
                message: "You have add a five resume",
                className:'successNotification',
                duration: 3
            });

        } else {
            modelTitle = "Add Resume";
            modelState = !this.state.resumeUploadModal;
            modelBodyData = <div className="user-section">
                                    <div className="col-md-12">
                                        <div className="form-group">
                                            <label className="pf-label" htmlFor="file">Upload Resume</label><br/>
                                            <input type="file" id="resumeUpload" className="p-input" onChange={(e)=>{this.onChange1(e)}} accept=".xlsx,.xls,.doc,.docx,.ppt, .pptx,.txt,.pdf" />
                                        </div> 
                                    </div>
                                    {this.state.resumeWithName &&
                                        <div className="col-md-12 link-flex m-change-r">
                                            <div className="form-group">
                                                <label className="pf-label">Change Resume Name</label><br/>
                                                <input type="text" className="form-control singup-control" name="resumeWithName" value={this.state.resumeWithName} onChange={this.handleChange} /> 
                                                {/*<span className="pf-label border-sqr"><a href={process.env.REACT_APP_SERVER_IMAGE_BUCKET+"/"+ProfileDetail.resume}>{ProfileDetail.resume}</a> </span>*/}
                                            </div>
                                        </div>
                                    }
                            </div>
            modelFooterData = <span>
                                <Button className="save-btn update-btn" onClick={this.upDateProfileResume} disabled={this.state.resumeUploadSuccess} >Update Resume</Button>
                                <Button className="cancel-btn" onClick={this.addNewResume}>Cancel</Button>
                            </span>
            modelAction = this.addNewResume

            this.setState({
                resumeWithName: "",
                resumeUploadModal: !this.state.resumeUploadModal
            })
        }
    }

    deleteConfmModal = () => {
        modelState = !this.state.deleteConfirmModal
        this.setState({
            deleteConfirmModal: !this.state.deleteConfirmModal
        })
    }

    deleteConfmModalAccount = () => {
        modelTitle = "Deactivate Account!";
        modelState = !this.state.deleteConfmModalAccount
        modelBodyData = <div className="user-section">
                            <div className="row">
                                <div className="col-md-12">
                                    <h6>Are You Sure You Want Deactivate Your Account!</h6>
                                   
                                </div>
                            </div>
                        </div>
        modelFooterData = <span>
                            <Button className="cnf-btn update-btn" onClick={this.deleteAccountOk}>Confirm</Button>
                            <Button type="cancel" onClick={this.deleteConfmModalAccount}>Cancel</Button>
                        </span>
        modelAction = this.deleteConfmModalAccount;

        this.setState({
            deleteConfmModalAccount: !this.state.deleteConfmModalAccount
        })
    }

    deleteAccountOk = (data) => {
        this.props.deactivateAccountAction()
    }

    deleteResume = (data) => {
        modelTitle = "Delete"
        modelState = !this.state.deleteConfirmModal;
        modelBodyData = <div className="user-section">
                <div className="col-md-12">
                    <h6>Are You Sure You Want Delete</h6>
                    <p><a href={process.env.REACT_APP_SERVER_IMAGE_BUCKET+"/"+this.state.deleteResumeFile.resumeImage}>{this.state.deleteResumeFile.name}</a></p>
                </div>
            </div>

        modelFooterData = <span>
                <Button className="save-btn update-btn" onClick={this.deleteResumeOk}>Ok</Button>
                <Button type="cancel" onClick={this.deleteConfmModal}>Cancel</Button>
            </span>
        modelAction = this.deleteConfModal

        this.setState({
            deleteResumeFile: data,
            deleteConfirmModal: !this.state.deleteConfirmModal
        })
    }

    deleteResumeOk = (data) => {
        let deleteResumeFile = this.state.deleteResumeFile;
        this.setState({
            deleteRequest: true
        })
        this.props.deleteResumeAction(deleteResumeFile)
    }

    handleChangeAddress() {
        this.setState({});
    }

    onresumeShowName(cell, row, rowIndex) {
        if (row && row.updatedAt) {
            return (this.formatDate(row.updatedAt))
        } else {
            return <span>-</span>
        }
    }

    onGetProjectSEDate(cell, row, rowIndex) {
        if (row && row.updatedAt) {
            return (this.formatDate(row.updatedAt))
        } else {
            return <span>-</span>
        }
    }

    dowloadResume(cell, row, rowIndex) {
        if (row && row.updatedAt) {
            let fileUrl = process.env.REACT_APP_SERVER_IMAGE_BUCKET + "/" + row.resumeImage;
            return <div><a href={fileUrl} download={row.userEmail}><i className="fa fa-cloud-download"></i></a></div>
        } else {
            return <span>-</span>
        }
    }

    showImage(resumeImage) {
        if (resumeImage) {
            //let fileUrl="http://192.168.0.132:83/public/uploads/9dcdd680-82a6-46d2-8974-09e8041d0a48.docx";
            let fileUrl = process.env.REACT_APP_SERVER_IMAGE_BUCKET + "/" + resumeImage;
            return fileUrl;
        } else {
            return <span>-</span>
        }
    }

    sizePerPageListChange(sizePerPage) {
        this.setState({
            sizePerPage: sizePerPage
        })
    }

    onPageChange(page, sizePerPage) {
        this.setState({
            currentPage: page,
            sizePerPage: sizePerPage,
            requestServer: true
        })
        this.resumeList(sizePerPage, (page - 1));
    }


    handleTab = (type, e) => {
        this.setState({
            tabTypeShow: type
        })
        $(".tab-pane").removeClass("active")
        $("a").removeClass("active")
        $("#" + type).addClass("active")
        $("#btn" + type).addClass("active")
    }

    changeImage = (e) => {
        e.preventDefault();
        this.setState({
            imageUpload: true
        })
        var file = document.getElementById("file").files[0];
        this.props.uploadResumeFile(file)
    }

    render() {

        const { requestServer, ProfileDetail, resumeList, cityOption } = this.state
        let resumeArr = ProfileDetail.resume ? ProfileDetail.resume : [];
        if (this.state.resumeWithName) {
            modelBodyData = <div className="row user-section">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label className="pf-label" htmlFor="file">Upload Resume</label><br/>
                                 <input type="file" id="resumeUpload" className="p-input" onChange={(e)=>{this.onChange1(e)}} accept=".xlsx,.xls,.doc,.docx,.ppt, .pptx,.txt,.pdf" />
                            </div> 
                        </div>
                        {this.state.resumeWithName &&
                            <div className="col-md-12 link-flex m-change-r">
                                <div className="form-group">
                                    <label className="pf-label">Change Resume Name</label><br/>
                                    <input type="text" className="form-control singup-control" name="resumeWithName" value={this.state.resumeWithName} onChange={this.handleChange} /> 
                                    {/*<span className="pf-label border-sqr"><a href={process.env.REACT_APP_SERVER_IMAGE_BUCKET+"/"+ProfileDetail.resume}>{ProfileDetail.resume}</a> </span>*/}
                                </div>
                            </div>
                        }
                        </div>
            modelFooterData = <span>
                                <Button className="save-btn update-btn" onClick={this.upDateProfileResume} disabled={this.state.resumeUploadSuccess} >Update Resume</Button>
                                <Button className="cancel-btn" onClick={this.addNewResume}>Cancel</Button>
                            </span>
        }
        if (requestServer) {
            className = "pageloading";
        } else {
            className = "";
        }
        var options = {
            onPageChange: this.onPageChange.bind(this),
            page: this.state.currentPage,
            //onSizePerPageList: this.sizePerPageListChange.bind(this),
            //sizePerPage:this.state.sizePerPage,
            paginationPosition: 'bottom', // default is bottom, top and both is all available
            alwaysShowAllBtns: true,
            prePage: 'Prev', // Previous page button text
            nextPage: 'Next', // Next page button text
            firstPage: 'First', // First page button text
            lastPage: 'Last',

        };

        let shortBio = "";
        if (ProfileDetail.shortBio !== undefined) {
            shortBio = ProfileDetail.shortBio
            let text1 = shortBio;
            let text2 = "";
            if (shortBio.length > 100) {
                text1 = shortBio.substr(0, 1000);
                text2 = shortBio.substr(100, shortBio.length);
                shortBio =
                    <span className="bio-text">
                        <div className="bio-text">{text1}<span id="dots">...</span><span id="more">{text2}</span></div>
                        <span onClick={this.myFunction} id="myBtn" className="readMore-btn"><a>Read more</a></span>
                    </span>

            } else {
                shortBio = <span className="bio-text">{text1}</span>
            }
        }

        return (
            <div>
                <div className={"pageForLoading "+className}>
                    <div className="wrap">
                      <div className="loading">
                            <img src={loadingImage} alt="Loading" />
                      </div>
                    </div> 
                </div>
                <div className="all-page-wrapper">
                    <Header props={this.props }/>
                      <div className="page-wrapper">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-3">
                                   <div className="profile-sidebar">
                                       <ul>
                                          <li><a className="active" id="btntab" onClick={this.handleTab.bind(this,"tab")} data-toggle="tab" href="#tab-one">my account</a></li>
                                          {/*<li><a data-toggle="tab" id="btntabTwo" onClick={this.handleTab.bind(this,"tabTwo")} href="#tab-two">information</a></li>*/}
                                          <li><a data-toggle="tab" id="btntabThree" onClick={this.handleTab.bind(this,"tabThree")} >history</a></li>
                                          <li><a data-toggle="tab" id="btntabFour" onClick={this.handleTab.bind(this,"tabFour")}>Message</a></li>
                                          {/*<li><a data-toggle="tab" id="btntabFour" onClick={this.handleTab.bind(this,"tabFour")} href="#tab-four">resume status</a></li>*/}
                                       </ul>
                                   </div>
                                </div>
                                <div className="col-md-9">
                                    <div className="profile-rightbar profile-content">
                                        {this.state.tabTypeShow ==="tab" &&
                                            <div className="tab-pane myaccount active" id="tab">
                                                <div className="profile-title">
                                                   <h3 className="ac-head">My Account</h3>
                                                </div>
                                                <div className="user-section">
                                                    <div className="user-image-block">
                                                        <div className="img-circular">
                                                            <img src={ProfileDetail.image?this.showImage(ProfileDetail.image):"https://www.pngfind.com/pngs/m/535-5357481_user-account-management-circle-user-icon-blue-hd.png"} alt="new" className="rounded" scale={4}  vertical={0} horizontal={5} />
                                                        </div>
                                                        <div className="img-edit">
                                                            <input type="button" className="edit-text" id="loadFile" value="Change image" onclick="document.getElementById('file').click();"/>
                                                            <input type="file" className="box__file" id="file" name="files" onChange={this.changeImage.bind(this)} accept="image" required/> 
                                                        </div>
                                                    </div>
                                                    <div className="user-block">
                                                        <h4 className="user-name">{ProfileDetail.firstName}</h4>
                                                        <h5 className="user-typ e">{ProfileDetail.userType}</h5>
                                                    </div>
                                                    {/*<div className="editbtn-block">
                                                        <a className="editBtn" onClick={this.editProfile}><i className="fa fa-pencil" aria-hidden="true"></i></a>
                                                    </div>*/}
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="form-group">
                                                            <div className="row">
                                                                <div className="bg-signup col-md-12">
                                                                    <div className="row">
                                                                        <div className="col-md-6">
                                                                            <div className="form-group">
                                                                                <label className="pf-label">Name<span>*</span></label> 
                                                                                <input type="text" className="form-control singup-control" name="firstName" onChange={this.handleChange}  placeholder="" value={ProfileDetail.firstName} />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            <div className="form-group">
                                                                                <label className="pf-label">Email<span>*</span></label>
                                                                                <input type="text" className="form-control singup-control" name="email"   placeholder="" value={ProfileDetail.email} disabled={true}/>
                                                                            </div>
                                                                        </div>
                                                                    {/*<div  className="col-md-2">
                                                                        <div className="form-group">
                                                                            <label className="pf-label">Area Code</label>
                                                                            <Select name="phoneExt" className="singup-control" closeMenuOnSelect={false} components={makeAnimated()} value={ProfileDetail.areaCode  } onChange={this.handleChangeSelectPhone.bind(this, "phoneExt" )} options={areaCode}  placeholder="Select Phone ext." />
                                                                        </div>
                                                                    </div>*/}
                                                                    <div  className="col-md-4">
                                                                        <div className="form-group">
                                                                            <label className="pf-label">Phone Number<span></span></label>
                                                                            <input type="text" className="form-control singup-control" name="phone" onChange={this.handleChange} placeholder="Phone Number" value={ProfileDetail.phone}  />
                                                                        </div>
                                                                    </div>
                                                                    </div>
                                                     
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                            <div className="form-group">
                                                                                <label className="pf-label" htmlFor="city">Job Preferred City </label>
                                                                                <Select name="city" className="singup-control"
                                                                                       isMulti
                                                                                       closeMenuOnSelect={false}
                                                                                       components={makeAnimated()}
                                                                                       value={ProfileDetail.companyAddress}
                                                                                       onChange={this.handleChangeSelectCity.bind(this, "city")}
                                                                                       options={cityOption}
                                                                                       disabled={true}
                                                                                       placeholder="Select City"
                                                                                    />
                                                                            </div>
                                                                        </div>
                                                                           <div className="col-md-12">
                                                                             <div className="form-group new-radio-block">
                                                                                    <label className="pf-label" htmlFor="city">Do you want to receive email notification for any communication through arightconnection</label>
                                                                                    <span className="radio-signups">
                                                                                        <input type="radio" className="new-radio-btn" name="radioNotificatio" onChange={this.handleChangeradioForRadio.bind(this,true)}  id="yesNotification" checked={ProfileDetail.messageEmailNotification===true}  /><label className="cus-radio-label" htmlFor="yesNotification">Yes</label>
                                                                                        <input type="radio" className="new-radio-btn" name="radioNotificatio" onChange={this.handleChangeradioForRadio.bind(this,false)} id="noNotification"  checked={ProfileDetail.messageEmailNotification===false}  /><label className="cus-radio-label" htmlFor="noNotification">No</label>
                                                                                    </span>
                                                                          
                                                                      
                                                                                {/*<input type="text" className="form-control" name="city" id="jobCity" value={ ProfileDetail && ProfileDetail.city}  placeholder=" City" disabled/>*/}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className="row">
                                                                        <div className="col-md-12">
                                                                        {!this.state.disabled &&
                                                                            <div className="button-block">
                                                                                <Button className="save-btn update-btn" onClick={this.upDateProfile} disabled={this.state.disabled}>Update</Button>
                                                                                <Button className="cancel-btn" onClick={this.cancelProfile}>Cancel</Button>
                                                                            </div>
                                                                        }    
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="profile-title">
                                                    <h3 className="ac-head">Resume Update</h3>
                                                    <span className="ac-head ad-resume" onClick={this.addNewResume}>
                                                        <i className="fa fa-plus-circle" aria-hidden="true"></i>Add Resume
                                                    </span>
                                                    {/*<div className="col-md-6" onClick={this.addMoreForResume}> + Add More</div>*/}
                                                </div>

                                                <div className=" scrol-f"> 
                                                    {resumeArr.map((resume,inde)=>(
                                                        <div className="row"> 
                                                            <span className="pf-label border-sqr spc-b">
                                                                <a  href={process.env.REACT_APP_SERVER_IMAGE_BUCKET+"/"+resume.resumeImage}>{resume.name}</a> 
                                                            </span> 
                                                            <span className="dete-dusbin" onClick={this.deleteResume.bind(this,resume)}>
                                                                <i className="fa fa-trash" aria-hidden="true"></i>
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>

                                                <div className="row">
                                                    <div className="col-md-12">
                                                        <div className="deactive-bb">
                                                            <span onClick={this.deleteConfmModalAccount}>Deactivate Account</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        
                                            <div className="tab-pane history" id="tabThree">
                                                <div className="history-block">
                                                    <h3 className="ac-head">History</h3>
                                                    <div className="resume-history">
                                                        {this.state.tabTypeShow ==="tabThree" &&
                                                            <div className="status-content">
                                                                <h4 className="history-status">Sent Resume <span className="resume-counting">{this.state.resumeCount}</span> </h4>
                                                                <div className="status-content outline-table-n">
                                                                    <BootstrapTable data={resumeList} options={options } remote={true} fetchInfo={ { dataTotalSize: this.state.resumeCount } } pagination>
                                                                        <TableHeaderColumn hidden={true} dataField='_id' isKey>object ID</TableHeaderColumn>
                                                                        <TableHeaderColumn width='292' tdAttr={{'data-attr':'Email' }} dataField='companyName' >Name</TableHeaderColumn>
                                                                        <TableHeaderColumn width='116' tdAttr={{'data-attr':'Date' }} dataField='' dataFormat={this.onGetProjectSEDate.bind(this)}>Date</TableHeaderColumn>
                                                                        <TableHeaderColumn width='110' tdAttr={{'data-attr':'Action' }} dataField=''dataFormat={this.dowloadResume.bind(this)} >Action</TableHeaderColumn>
                                                                    </BootstrapTable>
                                                                </div>                                               
                                                            </div>
                                                        }   
                                                    </div>
                                                </div>
                                            </div> 
                                       
                                            <div className="tab-pane history" id="tabFour">                                  
                                                <div className="history-block">
                                                    <h3 className="ac-head">Message</h3>
                                                    <div className="resume-history">
                                                        {this.state.tabTypeShow ==="tabFour" &&
                                                        <div className="status-content">
                                                            <Chat/>
                                                        </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                    </div>    
                                </div>
                            </div>
                        </div>
          
                        <ModalComponent title={modelTitle} modalState={modelState} modalBody={modelBodyData} FooterVl={modelFooterData} action={modelAction} />

                      </div>
                    <Footer />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        detailTypa: state.Profile.type,
        ProfileDetail: state.Profile.response,
        fields: state.home.response.data,
        image: state.FindRecCompany.resume,
        setCity: state.FindRecCompany.setCity,
        setCityB: state.FindRecCompany.setCityB,
        allCitySuggetion: state.FindRecCompany.allCitySuggetion,
        responseDelet: state.SendResume.responseDelet,
        resumeList: state.SendResume.response,
        resumeSent: state.SendResume.response
    };
}

export default withRouter(connect(mapStateToProps, {
    getAllHome,
    getProfileAction,
    resumeListAction,
    uploadResumeFile,
    deleteResumeAction,
    getAllCityAction,
    deactivateAccountAction,
    updateProfileAction

})(JobSeekerProfile));


// WEBPACK FOOTER //
// ./src/components/JobSeekers/Profile/JobSeekerProfile.js